module.exports = __webpack_public_path__ + "media/images/top/call-6a83d637daa09eb229b24d2f447a93d3.png";